import BaseView from './BaseView';
import Accordion from '../../classes/Accordion';
import StepBlock from "../../modules/StepBlock";

let view = null;

class Case extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {

		const accordions = this.container.querySelectorAll('[data-accordion]');
		accordions.forEach(accordion => {
			new Accordion(accordion);
		});

		const groups = new Map([
			[StepBlock, this.container.querySelectorAll('[data-step-block]')],
		]);

		super.createModules(groups);
	}
}

export default {
	namespace: 'single-case',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Case(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
